(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-cart-button"] && !Shopify.designMode) return;
  try {
    const buyButtons = document.querySelector('.js-buy-buttons');
    const floatingCartButton = document.querySelector('.js-floating-cart-button');
    const addToCartButton = document.querySelector('.js-submit-button');

    if (buyButtons && floatingCartButton && addToCartButton) {
        const visibilityObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        floatingCartButton.classList.remove('active');
                    } else {
                        floatingCartButton.classList.add('active');
                    }
                });
            },
            { threshold: 0 }
        );

        visibilityObserver.observe(buyButtons);

        // remove the animation class after it plays
        addToCartButton.addEventListener('animationend', () => {
            addToCartButton.classList.remove('focus-animation');
        });

        floatingCartButton.addEventListener('click', () => {
            // temporary observer to trigger button shimmer
            const scrollEndObserver = new IntersectionObserver(
                (entries) => {
                    const [entry] = entries;
                    if (entry.isIntersecting) {
                        addToCartButton.classList.add('focus-animation');
                        scrollEndObserver.disconnect();
                    }
                },
                { threshold: 1.0 }
            );

            scrollEndObserver.observe(buyButtons);
            buyButtons.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
  } catch(e) { console.error(e); }
})();

})();
